/* eslint-disable jsx-a11y/label-has-associated-control */
import React, { useEffect, useState } from 'react';
import { Formik, FormikHelpers } from 'formik';

import { useHistory } from 'react-router-dom';

import moment from 'moment';

import { LuCalendarRange, LuUsers } from 'react-icons/lu';

import { Button } from 'primereact/button';
import { ListBox } from 'primereact/listbox';

// import ReactDOM from 'react-dom';
import api from '../../../../../services/api';
import useResponsaveis from '../../../../../hooks/useResponsaveis';

import { useToast } from '../../../../../hooks/toast';

import {
  DateFilter,
  Field,
  FilterStyles,
  Section,
} from '../../../../../components/FilterKit';

interface SearchData {
  sector: string | string[];
  inCharge: string;
  proc_data_ajuiz_inicio: Date;
  proc_data_ajuiz_final: Date;
}

const SearchHourAttorneySimplified:React.FC = () => {
  const { addToast } = useToast();
  const history = useHistory();

  const startOfMonth = moment().startOf('month').format('YYYY-MM-DD hh:mm:ss');
  const endOfMonth = moment().endOf('month').format('YYYY-MM-DD hh:mm:ss');

  const [
    initialRegistrationDate, setInitialRegistrationDate,
  ] = useState<string | Date | Date[] | null>(new Date(startOfMonth));
  const [
    finalRegistrationDate, setFinalRegistrationDate,
  ] = useState<string | Date | Date[] | null>(new Date(endOfMonth));

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [sectorOptions, setSectorOptions] = useState([{}]);
  const [sectorValue, setSectorValue] = useState(['all']);
  const [inCharge, setInCharge] = useState(['global|all']);
  const [dateFilterType, setDateFilterType] = useState('data');

  const handleClear = () => {
    setInitialRegistrationDate(new Date(startOfMonth));
    setFinalRegistrationDate(new Date(endOfMonth));
    setSectorValue(['all']);
    setInCharge(['global|all']);
    setDateFilterType('data');
  };

  const initialValues: SearchData = {
    sector: 'all',
    inCharge: 'global|0',
    proc_data_ajuiz_inicio: new Date(startOfMonth),
    proc_data_ajuiz_final: new Date(endOfMonth),
  };

  const validationSchema = null;

  useEffect(() => {
    (async () => {
      const sectorArray = [{ name: '', value: '' }];

      await api.get('/management/attorneys/show/inchargelawsuits/attorneys').then((response) => {
        if (response.data.length > 0) {
          sectorArray.push({
            name: 'Todos',
            value: 'all',
          });
          response.data.map((sector: {
            setor_adv: string
          }) => (
            sectorArray.push({
              name: sector.setor_adv,
              value: sector.setor_adv,
            })
          ));
        }
      });

      await api.get('/management/attorneys/show/inchargelawsuits/others').then((response) => {
        if (response.data.length > 0) {
          response.data.forEach((sector: {
            setor_adm: string
          }) => {
            // if (sectorOptions.indexOf(sector.setor_adm) === -1) {
            sectorArray.push({
              name: sector.setor_adm,
              value: sector.setor_adm,
            });
            // }
          });
        }
      });

      sectorArray.splice(0, 1);
      setSectorOptions(sectorArray);
      // }
    })();
  }, []);

    const { inChargeOptions, filterAttorneysInCharge } = useResponsaveis({
    urlAdvogados: `management/attorneys/show/all/active/lawsuit/${sessionStorage.getItem('setor')}/${sessionStorage.getItem('categoria')}`,
    todos: {
        label: 'Todos',
        items: [
          { label: 'Todos', value: 'global|all' },
        ],
      },
    estiloLista: 'padding-left: 10px;',
  });

  const handleOnSubmit = async (
    values: SearchData,
    { setSubmitting }: FormikHelpers<SearchData>,
  ) => {
    try {
      // const access = JSON.parse(sessionStorage.getItem('@Jurisnet:access') || '{}');
      const access = JSON.parse(localStorage.getItem('@Jurisnet:access') || '{}');

      let menu = '';
      if (access) {
        menu = access.menu;
      }
      const searchFormData = {
        sector: sectorValue,
        inCharge,
        dateFilterType,
        proc_data_ajuiz_inicio: initialRegistrationDate,
        proc_data_ajuiz_final: finalRegistrationDate,
        menu,
      };

      history.push({
        pathname: '/report/hour/attorney/simplified',
        state: searchFormData,
      });

      setSubmitting(false);
    } catch (error) {
      addToast({
        type: 'error',
        title: 'Ocorreu um problema',
        description:
              'Tente repetir a pesquisa ou contate o administrador.',
      });
    }
  };

  return (
    <FilterStyles>
      <Formik
        onSubmit={handleOnSubmit}
        validationSchema={validationSchema}
        enableReinitialize
        initialValues={initialValues}
      >
        {({
          isSubmitting,
          handleSubmit,
          handleReset,
        }) => (
          <form className="card search-card" onSubmit={handleSubmit}>
            <header className="search-title">
              <h3>Relatório de Horas por Profissional (Simplificado) - Modelo VIII</h3>
              <span className="search-hint">
                Escolha setores, responsáveis e o período de registro.
              </span>
            </header>

            <div className="search-grid">
              <div className="search-col">
                <Section icon={<LuUsers />} title="Setor e responsável">
                  <div className="row r2">
                    <Field id="sector" label="Setor">
                      <ListBox
                        id="sector"
                        name="sector"
                        options={sectorOptions}
                        onChange={(e) => {
                          setSectorValue(e.target.value);
                          filterAttorneysInCharge(e.target.value);
                        }}
                        value={sectorValue}
                        className="inputfield w-full"
                        optionLabel="name"
                        optionValue="value"
                        multiple
                        filter
                        filterBy="name"
                        listStyle={{ maxHeight: '330px' }}
                      />
                    </Field>
                    <Field id="inChargeListbox" label="Responsável">
                      <ListBox
                        id="inChargeListbox"
                        name="inChargeListbox"
                        options={inChargeOptions}
                        // eslint-disable-next-line @typescript-eslint/no-explicit-any
                        onChange={(e: {value: any}) => setInCharge(e.value)}
                        metaKeySelection={false}
                        value={inCharge}
                        className="inputfield w-full"
                        optionLabel="label"
                        optionGroupLabel="label"
                        optionGroupChildren="items"
                        multiple
                        filter
                        filterBy="label"
                        listStyle={{ maxHeight: '330px' }}
                      />
                    </Field>
                  </div>
                </Section>
              </div>

              <div className="search-col">
                <Section icon={<LuCalendarRange />} title="Período">
                  <DateFilter
                    id="proc_data_ajuiz"
                    label="Data de registro"
                    withMode
                    value={{
                      mode: dateFilterType === 'periodo' ? 'periodo' : 'data',
                      start: initialRegistrationDate as Date | null,
                      end: finalRegistrationDate as Date | null,
                    }}
                    onChange={(next) => {
                      setDateFilterType(next.mode);
                      setInitialRegistrationDate(next.start);
                      setFinalRegistrationDate(next.end);
                    }}
                  />
                </Section>
              </div>
            </div>

            <footer className="search-actions">
              <span />
              <div className="buttons">
                <Button
                  icon="pi pi-undo"
                  iconPos="left"
                  label="Limpar campos"
                  className="p-button-outlined p-button-secondary"
                  type="button"
                  onClick={() => {
                    handleClear();
                    handleReset();
                  }}
                />
                <Button
                  icon="pi pi-check"
                  iconPos="left"
                  label="Pesquisar processos"
                  type="submit"
                  disabled={isSubmitting}
                />
              </div>
            </footer>
          </form>
        )}
      </Formik>
    </FilterStyles>
  );
};

export default SearchHourAttorneySimplified;
